export function getMetaDatabaseActionTypes(type)
{
    return {
        LOADING: `ADMIN_META_DATABASE_${type}_LOADING`,
        LOADED: `ADMIN_META_DATABASE_${type}_LOADED`,
        BATCH_LOADING: `ADMIN_META_DATABASE_${type}_BATCH_LOADING`,
        ERROR: `ADMIN_META_DATABASE_${type}_ERROR`,
        BATCH_ERROR: `ADMIN_META_DATABASE_${type}_BATCH_ERROR`,
        SET_LOADED_INCLUDES: `ADMIN_META_DATABASE_${type}_SET_LOADED_INCLUDES`,
        FILTER: `ADMIN_META_DATABASE_${type}_FILTER`,
    };
}

export function getMetaDatabaseActionCreators(type)
{
    const ACTIONS = getMetaDatabaseActionTypes(type);

    return {
        _loading(id, status, includes)
        {
            return { type: ACTIONS.LOADING, payload: { id, status, includes } };
        },

        _loaded(id, status)
        {
            return { type: ACTIONS.LOADED, payload: { id, status } };
        },

        _filters(id, filters)
        {
            return { type: ACTIONS.FILTER, payload: { id, filters } };
        },

        _batchLoading(ids, status, includes)
        {
            if (!Array.isArray(ids))
            {
                throw Error('For batch loading, you need to provide a valid array of ids');
            }

            return { type: ACTIONS.BATCH_LOADING, payload: { ids, status, includes } };
        },

        _error(id, error)
        {
            return { type: ACTIONS.ERROR, payload: { id, error } };
        },

        _batchError(ids, error)
        {
            if (!Array.isArray(ids))
            {
                throw Error('For batch error, you need to provide a valid array of ids');
            }

            return { type: ACTIONS.BATCH_ERROR, payload: { ids, error } };
        },

        _setLoadedIncludes(id, includes)
        {
            return { type: ACTIONS.SET_LOADED_INCLUDES, payload: { id, includes } };
        },
    };
}
